enum PanelType {
  HealthPlanAndPbm = 'HealthPlanAndPbm',
  OncologyCenter = 'OncologyCenter',
  HealthPlan = 'HealthPlan',
  HospitalNetwork = 'HospitalNetwork',
  HealthPlanAndHospitalNetwork = 'HealthPlanAndHospitalNetwork',
  PhysicianSurvey = 'PhysicianSurvey',
}
export default PanelType;

export const getPanelTypeText = (type: PanelType) => {
  switch (type) {
    case PanelType.HealthPlanAndPbm:
      return 'Health Plan & PBM';
    case PanelType.OncologyCenter:
      return 'Oncology Center';
    case PanelType.HealthPlan:
      return 'Health Plan';
    case PanelType.HospitalNetwork:
      return 'Hospital System';
    case PanelType.HealthPlanAndHospitalNetwork:
      return 'Health Plan & Hospital System';
    case PanelType.PhysicianSurvey:
      return 'Physician Survey';  
    default:
      throw Error(`Unknown PanelType (${type})`);
  }
};
